import {LogIn} from "lucide-react";
import direDawnIcon from "@assets/diredawn_icon.png";
import {OIDC_LOGIN_PATH} from "@/auth/AuthNavigation.ts";
import {Button} from "@/components/ui/button.tsx";
import {Card, CardContent, CardDescription, CardHeader, CardTitle} from "@/components/ui/card.tsx";

export default function LoginView() {
    const startLogin = () => window.location.replace(OIDC_LOGIN_PATH);

    return <main className="grid min-h-full place-items-center p-6">
        <title>Anmelden | DireDawn</title>
        <Card className="w-full max-w-sm text-center">
            <CardHeader className="justify-items-center gap-4">
                <img src={direDawnIcon} className="size-28" alt="DireDawn"/>
                <div className="space-y-2">
                    <CardTitle className="text-2xl">Willkommen bei DireDawn</CardTitle>
                    <CardDescription>Melde dich an, um deine Kampagnen zu verwalten.</CardDescription>
                </div>
            </CardHeader>
            <CardContent>
                <Button type="button" size="lg" className="w-full" onClick={startLogin}>
                    <LogIn/>
                    Mit Authentik anmelden
                </Button>
            </CardContent>
        </Card>
    </main>;
}
